export const SUPPORT_EMAIL = "info@redemptafoundation.com"
